module.exports = __webpack_public_path__ + "img/Kg.e2dff754.png";